import forge from "node-forge";
import axios from "axios";
import store from "../../main";

async function Goodman(file) {

    let option = {
        pic: file
    }
    const DOM = 'https://app.sangin-savaran.com/upload_pic';
    let config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    }

    return await axios.post(DOM, option, config);
}

async function Heisenberg(option, url, uid) {

    option.apikey = 'man_is_a_dream2023'
    if (uid) {
        option.user_id = PinkMan(localStorage.getItem('uid'), 'de')
    }
    if (store.state.user_type !== null) {
        option.users_type_id = PinkMan(store.state.user_type, 'de')
    }

    const world = '4444555566667777';
    const DOM = 'https://app.sangin-savaran.com/';
    const cipher = forge.cipher.createCipher('AES-CBC', world);
    // رمزگذاری داده
    cipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
    cipher.update(forge.util.createBuffer(unescape(encodeURIComponent(JSON.stringify(option)))));
    cipher.finish();
    let data = forge.util.encode64(cipher.output.data);

    return await axios.post(DOM + url, {data: data});
}

function PinkMan(data, type) {

    const world = '4444555566667777';

    if (type === 'en') {

        const cipher = forge.cipher.createCipher('AES-CBC', world);
        cipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
        cipher.update(forge.util.createBuffer(unescape(encodeURIComponent(JSON.stringify(data)))));
        cipher.finish();
        return forge.util.encode64(cipher.output.data)
    }

    if (type === 'de') {

        const decipher = forge.cipher.createDecipher('AES-CBC', world);
        decipher.start({iv: 'I8zyA4lVhMCaJ5Kg'});
        decipher.update(forge.util.createBuffer(forge.util.decode64(data)));
        decipher.finish();
        return JSON.parse(decipher.output.toString())
    }

}


export default {Heisenberg, PinkMan, Goodman};